import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        crowdfundingFees: [
          !_.isNil(entity?.parameters?.crowdfundingFees)
            ? entity.parameters.crowdfundingFees * 100
            : null,
          !!this.feesRequired(entity?.parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
        crowdfundingIncludeFeesInSubscriptionAmount: [
          entity?.parameters?.crowdfundingIncludeFeesInSubscriptionAmount ||
            false,
          !!this.includeFeesInSubscriptionAmountRequired(entity?.parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  feesRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.CROWDFUNDING_FEES,
      )?.required === 'MANDATORY' || false
    );
  }
  includeFeesInSubscriptionAmountRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT,
      )?.required === 'MANDATORY' || false
    );
  }
  getAdditionalQuestions(parameters: Parameters, type: any) {
    return parameters?.additionalQuestions?.find(q => q?.id === type);
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);
    formValue?.forEach(item => {
      item.parameters.crowdfundingFees =
        +item.parameters.crowdfundingFees / 100;
    });
    return formValue;
  }
}
